import { PeekDialog, PeekDialogContent } from "@piiqtechnologies/ui-components";
import React from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { PublishToGMBSteps } from "./publish-to-GMB-steps";
export const SpacePublishToGMBDialog = ({ spaceId, open, onClose, spaceType, staged, }) => {
    const intl = useIntl();
    return (React.createElement(PeekDialog, { maxWidth: "xs", fullWidth: true, hasCloseIcon: true, title: intl.formatMessage(messages.spacePublishToGMBTitle), open: open, onClose: onClose },
        React.createElement(PeekDialogContent, null,
            React.createElement(PublishToGMBSteps, { spaceId: spaceId, onPublishToGMBSuccess: onClose, staged: staged, spaceType: spaceType }))));
};
export default SpacePublishToGMBDialog;
